export default "/images/vendor/flag-icon-css/flags/1x1/wf.svg?55c63880d979782164502e87292e35b5";